import { render, staticRenderFns } from "./SlcNewsItemShort.vue?vue&type=template&id=4d163c1a&"
import script from "./SlcNewsItemShort.vue?vue&type=script&lang=ts&"
export * from "./SlcNewsItemShort.vue?vue&type=script&lang=ts&"
import style0 from "./SlcNewsItemShort.vue?vue&type=style&index=0&postcss=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
